import React, { useEffect, useState, useMemo } from "react";
import {
  MapContainer,
  TileLayer,
  Marker,
  Popup,
  Polyline,
  useMap,
} from "react-leaflet";
import L from "leaflet";
import axios from "axios";
import "leaflet/dist/leaflet.css";

// Fix icone Leaflet
import markerIcon from "leaflet/dist/images/marker-icon.png";
import markerShadow from "leaflet/dist/images/marker-shadow.png";
let DefaultIcon = L.icon({
  iconUrl: markerIcon,
  shadowUrl: markerShadow,
  iconSize: [25, 41],
  iconAnchor: [12, 41],
});
L.Marker.prototype.options.icon = DefaultIcon;

const GOOGLE_API_KEY = "AIzaSyD16h98hJe26HkkEvzKPbH2WytgT5srggM";

// Controller per lo zoom
// Controller aggiornato con zoom meno profondo
const MapController = ({ coords }) => {
  const map = useMap();
  useEffect(() => {
    if (coords) {
      // Zoom impostato a 5 (un punto meno rispetto a 6)
      map.flyTo(coords, 5, { animate: true, duration: 1.5 });
    }
  }, [coords, map]);
  return null;
};

// Funzione per creare un'icona colorata personalizzata
const createIcon = (color) => {
  return new L.DivIcon({
    html: `<svg width="25" height="41" viewBox="0 0 25 41" xmlns="http://www.w3.org/2000/svg">
             <path d="M12.5 0C5.596 0 0 5.596 0 12.5C0 21.875 12.5 41 12.5 41C12.5 41 25 21.875 25 12.5C25 5.596 19.404 0 12.5 0Z" 
             fill="${color}" stroke="#000" stroke-width="1"/>
             <circle cx="12.5" cy="12.5" r="4" fill="white" />
           </svg>`,
    className: "",
    iconSize: [25, 41],
    iconAnchor: [12, 41],
    popupAnchor: [1, -34],
  });
};

const iconFornitore = createIcon("rgb(141, 141, 141)"); // Rosso
const iconCliente = createIcon("#b81f25"); // Grigio chiaro

const MappaCrossDocking = () => {
  const [percorsi, setPercorsi] = useState([]);
  const [selectedId, setSelectedId] = useState(null);
  const [loading, setLoading] = useState(true);

  // --- Geocoding Function (identica alla precedente) ---
  const getCoords = async (item, tipo) => {
    const prov = item[`PROVINCIA ${tipo}`];
    const naz = item[`NAZIONE ${tipo}`];
    const query = prov ? `${prov}, ${naz}` : naz;
    if (!query) return [45.0, 12.0];
    const cache = JSON.parse(localStorage.getItem("geocodeCache") || "{}");
    if (cache[query]) return cache[query];
    try {
      const res = await axios.get(
        "https://maps.googleapis.com/maps/api/geocode/json",
        {
          params: { address: query, key: GOOGLE_API_KEY },
        },
      );
      if (res.data.status === "OK") {
        const loc = res.data.results[0].geometry.location;
        const coords = [loc.lat, loc.lng];
        cache[query] = coords;
        localStorage.setItem("geocodeCache", JSON.stringify(cache));
        return coords;
      }
    } catch (e) {
      return [45.0, 12.0];
    }
    return [45.0, 12.0];
  };

  useEffect(() => {
const fetchData = async () => {
  try {
    // Aggiungiamo un timestamp per evitare la cache del browser
    const res = await fetch(`./ordini_urgenti.json?nocache=${new Date().getTime()}`);
    const data = await res.json();
    
    console.log("Dati ricevuti dal JSON:", data); // Fondamentale per il debug

    // CONTROLLO SICURO: 
    // Se CROSS_DOCKING è dentro un array [0], lo prendiamo, altrimenti prendiamo CROSS_DOCKING direttamente.
    // Se non esiste nulla, usiamo un array vuoto [] per non far crashare .filter()
    let listaRaw = [];
    if (Array.isArray(data.CROSS_DOCKING)) {
        listaRaw = data.CROSS_DOCKING;
    } else if (data.CROSS_DOCKING && Array.isArray(data.CROSS_DOCKING[0])) {
        listaRaw = data.CROSS_DOCKING[0];
    }

    // Ora .filter() non darà più errore perché listaRaw è sicuramente un array
    const validi = listaRaw.filter(item => item && item["NAZIONE CLIENTE"] && item.Is_Totale === "0");

    const elaborati = [];
    for (let i = 0; i < validi.length; i++) {
      const item = validi[i];
      const start = await getCoords(item, "FORNITORE");
      const end = await getCoords(item, "CLIENTE");
      elaborati.push({ ...item, id_u: `${item.Doc_Cliente}-${i}`, start, end });
      
      // Aggiorna lo stato man mano
      setPercorsi([...elaborati]);
    }
  } catch (err) {
    console.error("Errore nel caricamento del file locale:", err);
  } finally {
    setLoading(false);
  }
};
    fetchData();
  }, []);

  const selectedPath = useMemo(
    () => percorsi.find((p) => p.id_u === selectedId),
    [selectedId, percorsi],
  );

  return (
    <div
      className="bg-dark sidebar-mappa text-light widget-client2 ombra tb"
      style={{
        borderRadius: "10px",
        border: "1px solid #444",
        height: "100%", // Prende l'altezza del contenitore padre
        display: "flex",
        flexDirection: "column",
        position: "relative", // Necessario per contenere la mappa absolute se serve
        overflow: "hidden", // Evita che la mappa esca dai bordi arrotondati
      }}
    >
      <style>
        {`
    /* Nasconde la scrollbar per Chrome, Safari e Opera */
    .sidebar-mappa::-webkit-scrollbar {
      display: none !important;
    }

    /* Nasconde la scrollbar per Firefox */
    .sidebar-mappa {
      scrollbar-width: none !important; /* Firefox */
      -ms-overflow-style: none !important;  /* IE e Edge */
    }
  `}
      </style>
      <div style={{ display: "flex", flex: 1, minHeight: 0 }}>
        {/* SIDEBAR */}
        <div
          className="sidebar-mappa"
          style={{
            width: "300px",
            overflowY: "auto",
            background: "#111",
            borderRight: "1px solid #333",
            padding: "10px",
          }}
        >
          <small className="text-title">PERCORSO ORDINI</small>
          {percorsi.map((p) => (
            <div
              key={p.id_u}
              onClick={() => setSelectedId(p.id_u)}
              style={{
                padding: "8px",
                marginBottom: "5px",
                borderRadius: "5px",
                cursor: "pointer",
                fontSize: "0.8rem",
                background: selectedId === p.id_u ? "#5f1e1e" : "#222",
                border: `1px solid ${selectedId === p.id_u ? "#b81f25" : "#444"}`,
              }}
            >
              <strong>{p.Cliente}</strong>
              <div style={{ fontSize: "0.7rem", color: "#aaa" }}>
                Da: {p.Fornitore}
              </div>
            </div>
          ))}
        </div>

        {/* MAPPA - IMPORTANTE: flex: 1 e minHeight assicurano la visibilità */}
        <div style={{ flex: 1, position: "relative", minHeight: "400px" }}>
          <MapContainer
            center={[45.0, 15.0]}
            zoom={4}
            style={{ height: "100%", width: "100%", background: "#1a1a1a" }}
          >
            <TileLayer url="https://{s}.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}{r}.png" />

            {percorsi
              .filter((p) => p.id_u === selectedId)
              .map((p) => (
                <React.Fragment key={p.id_u}>
                  {/* Marker Fornitore - ROSSO */}
                  <Marker position={p.start} icon={iconFornitore}>
                    <Popup>
                      <strong>FORNITORE:</strong>
                      <br />
                      {p.Fornitore}
                    </Popup>
                  </Marker>

                  {/* Marker Cliente - GRIGIO CHIARO */}
                  <Marker position={p.end} icon={iconCliente}>
                    <Popup>
                      <strong>CLIENTE:</strong>
                      <br />
                      {p.Cliente}
                    </Popup>
                  </Marker>

                  {/* Linea Tracciato */}
                  <Polyline
                    positions={[p.start, p.end]}
                    pathOptions={{
                      color: "#b81f25",
                      weight: 4,
                      opacity: 0.8,
                      dashArray: "10, 10",
                    }}
                  />
                </React.Fragment>
              ))}
            {selectedPath && <MapController coords={selectedPath.start} />}
          </MapContainer>
        </div>
      </div>
    </div>
  );
};

export default MappaCrossDocking;
